// Shared organization context for the API client.
// Set by AuthContext when user selects an org, read by apiClient on every request.
let _organizationId = null;

export function getOrganizationId() {
  return _organizationId;
}

export function setOrganizationId(id) {
  _organizationId = id;
}
